<template>
	<v-card flat tile class="surfaceDark d-flex justify-center">
		<v-card-text class="col-10">
			<v-row>

				<v-col class="col-lg-2 col-md-6 col-6">
					<p class="text-overline primary--text text--lighten-1 font-weight-bold mb-2">OTHER USEFUL LINKS</p>
					<div v-for="(item, i) in otherUsefulLinks" :key="i" three-line>
						<a class="text-caption primary--text text--darken-1">{{ item.label }}</a>
					</div>
				</v-col>

				<v-col class="col-lg-2 col-md-6 col-6">
					<div class="mb-4">
						<p class="text-overline primary--text text--lighten-1 font-weight-bold mb-2">NEED HELP NOW?</p>
						<div v-for="(item, i) in needHelpNow" :key="i" three-line>
							<a class="text-caption primary--text text--darken-1">{{ item.label }}</a>
						</div>
					</div>
					<p class="text-overline primary--text text--lighten-1 font-weight-bold mt-4 mb-2">CHANGE REGION</p>
					<div class="d-flex align-center mt-1">
						English
						<v-btn class="ml-2" text icon><img width="24" src="../../assets/footer/sponsors/en-flag.png" style="cursor:pointer"/></v-btn>
					</div>
				</v-col>

				<v-col class="col-lg-3 col-md-6">
					<p class="text-overline primary--text text--lighten-1 font-weight-bold mb-2">CONTACT POINTS</p>
					<div class="mb-4">
						<div v-for="(item, i) in contactPoints" :key="i" three-line>
							<span class="text-caption primary--text text--darken-1">{{ `${item.label} ${item.value}` }}</span>
						</div>
					</div>
					<p class="text-overline primary--text text--lighten-1 font-weight-bold mb-2">SOCIAL MEDIA</p>
					<div class="d-flex">
						<v-btn text icon><v-icon medium class="mr-1"> mdi-youtube </v-icon></v-btn>
						<v-btn text icon><v-icon medium> mdi-facebook </v-icon></v-btn>
					</div>
				</v-col>

				<v-col class="col-lg-3 col-md-6">
					<p class="text-overline primary--text text--lighten-1 font-weight-bold mb-2">PAYMENT METHODS</p>
					<div class="text-caption primary--text text--darken-1">{{ paymentMethods.description }}</div>
					<v-img alt="UX" class="shrink mt-2" contain :src="paymentMethods.src" width="300" style="cursor:pointer" />
				</v-col>

			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	data() {
		return {}
	},
	computed: {
		otherUsefulLinks() {
			return this.$store.getters["Footer/otherUsefulLinks"]
		},
		needHelpNow() {
			return this.$store.getters["Footer/needHelpNow"]
		},
		contactPoints() {
			return this.$store.getters["Footer/contactPoints"]
		},
		socialMedia() {
			return this.$store.getters["Footer/socialMedia"]
		},
		paymentMethods() {
			return this.$store.getters["Footer/paymentMethods"]
		},
		subMenuItems() {
			return this.$store.getters["Drawer/subMenuItems"]
		},
	},
}
</script>

<style lang="sass" scoped>
.v-application .text-overline
	letter-spacing: -0.1px !important
.v-card__subtitle, .v-card__text, .v-card__title
	padding: 24px 0 !important
</style>
